// extracted by mini-css-extract-plugin
export default {"header":"CardContainer_header__DcedQ","heading_div":"CardContainer_heading_div__avyv0"};